module.exports = __webpack_public_path__ + "static/nslide2-2be032049c82ae8298ae94d1766fe778.png";